<template>
  <my_radio
    :titleWidth="titleWidth"
    :title="title"
    hiddenIsShow="false"
    :selectValue.sync="boxShadow.radio_val"
  >
    <div slot="pull_down_control">
      <my_color
        class="color-picker"
        :title="$t('view_back_top_edit_99')"
        :titleWidth="subTitleWidth"
        :color.sync="boxShadow.custom.color"
      ></my_color>
      <my_radio
        v-if="needDirection"
        :title="$t('components_my_animation_my_comb_animation_2289')"
        :titleWidth="subTitleWidth"
        :option="$store.state.options.shadowDirection"
        hiddenIsShow="false"
        :selectValue.sync="boxShadow.custom.direction"
      >
      </my_radio>
      <my_slider
        class="num_slider"
        :titleWidth="subTitleWidth"
        :title="$t('components_my_box_shadow_index_2296')"
        :value.sync="boxShadow.custom.x"
        :min="-50"
        :max="50"
        symbol="px"
      ></my_slider>
      <my_slider
        class="num_slider"
        :titleWidth="subTitleWidth"
        :title="$t('components_my_box_shadow_index_2297')"
        :value.sync="boxShadow.custom.y"
        :min="-50"
        :max="50"
        symbol="px"
      ></my_slider>
      <my_slider
        class="num_slider"
        :titleWidth="subTitleWidth"
        :title="$t('widgets_basic_floating_frame_edit_532')"
        :value.sync="boxShadow.custom.blur"
        :min="0"
        :max="20"
        symbol="px"
      ></my_slider>
      <my_slider
        v-if="needSpread"
        class="num_slider"
        :titleWidth="subTitleWidth"
        title="Spread："
        :value.sync="boxShadow.custom.spread"
        :min="0"
        :max="20"
        symbol="px"
      ></my_slider>
    </div>
  </my_radio>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: "my_box_shadow.vue",
  props: {
    titleWidth: {
      type: [Number, String],
      default: '45'
    },
    subTitleWidth: {
      type: [Number, String],
      default: '65'
    },
    title: {
      type: String,
      default: i18n.t('widgets_basic_floating_frame_edit_532')
    },
    option: {
      type: Array,
      default: function () {
        return this.$store.state.options.shadowConfig
      }
    },
    boxShadow: {
      type: Object
    },
    needDirection: {
      type: Boolean,
      default: false
    },
    needSpread: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      min: 0,
      max: 100,
    }
  },
  computed: {
    colorTitle() {
      return this.boxShadow.custom.seColor ? '默认' : ''
    }
  },
  methods: {}
}
</script>

<style scoped>
.my-label {
  display: inline-block;
  vertical-align: middle;
  text-align: right;
  margin-bottom: 12px;
}

.color-picker {
  display: inline-block;
  vertical-align: middle;
  padding-left: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_box_shadow/index.vue